import * as i0 from '@angular/core';
import { Injectable, Component, Input, NgModule } from '@angular/core';
import * as i1 from 'app-services-library';

class VdCountService {
    constructor() { }
}
VdCountService.ɵfac = function VdCountService_Factory(t) { return new (t || VdCountService)(); };
VdCountService.ɵprov = i0.ɵɵdefineInjectable({ token: VdCountService, factory: VdCountService.ɵfac, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCountService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

const _c0 = function (a0, a1) { return { "width": a0, "background-color": a1 }; };
const _c1 = function (a0, a1, a2) { return { "font-size": a0, "font-weight": a1, "color": a2 }; };
class VdCountComponent {
    constructor(appServicesLibraryService) {
        this.appServicesLibraryService = appServicesLibraryService;
    }
    ngOnInit() {
    }
    ngAfterViewInit() {
        this.appServicesLibraryService.reportLoaded();
    }
}
VdCountComponent.ɵfac = function VdCountComponent_Factory(t) { return new (t || VdCountComponent)(i0.ɵɵdirectiveInject(i1.AppServicesLibraryService)); };
VdCountComponent.ɵcmp = i0.ɵɵdefineComponent({ type: VdCountComponent, selectors: [["lib-vd-count"]], inputs: { inputParams: "inputParams" }, decls: 6, vars: 13, consts: [[1, "card-container"], [1, "staff-card-content"], [1, "staff-label", "common-bene-class-for-translation"], [1, "staff-count", "common-bene-class-for-translation"]], template: function VdCountComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "span", 2);
        i0.ɵɵtext(3);
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(4, "span", 3);
        i0.ɵɵtext(5);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction2(6, _c0, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.width, ctx.inputParams && ctx.inputParams.style && ctx.inputParams.style.backgroundColor ? ctx.inputParams.style.backgroundColor : "inherit"));
        i0.ɵɵadvance(2);
        i0.ɵɵtextInterpolate1(" ", ctx.inputParams == null ? null : ctx.inputParams.properties == null ? null : ctx.inputParams.properties.label, "");
        i0.ɵɵadvance(1);
        i0.ɵɵstyleMap(i0.ɵɵpureFunction3(9, _c1, ctx.inputParams == null ? null : ctx.inputParams.style == null ? null : ctx.inputParams.style.fontSize, ctx.inputParams && ctx.inputParams.style && ctx.inputParams.style.fontWeight ? ctx.inputParams.style.fontWeight : "normal", ctx.inputParams && ctx.inputParams.style && ctx.inputParams.style.color ? ctx.inputParams.style.color : "inherit"));
        i0.ɵɵadvance(1);
        i0.ɵɵtextInterpolate1(" ", ctx.inputParams == null ? null : ctx.inputParams.properties == null ? null : ctx.inputParams.properties.count, " ");
    } }, styles: [".card-container[_ngcontent-%COMP%]{display:flex;flex-direction:row;padding:16px;width:100%}.staff-card-content[_ngcontent-%COMP%]{background-color:#c9e9e9;border:1px solid #ccc;padding:12px 20px 12px 12px}.staff-label[_ngcontent-%COMP%]{font-size:14px;color:#131212;margin-right:12px}.staff-count[_ngcontent-%COMP%]{font-size:24px;position:relative;bottom:8px;left:8px;float:right}.staff-leave-card-content[_ngcontent-%COMP%]{display:flex;flex-direction:row;background-color:#f6eff6;border:1px solid #ccc;padding:12px 18px 1px 12px;margin-left:20px}"] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCountComponent, [{
        type: Component,
        args: [{
                selector: 'lib-vd-count',
                templateUrl: 'vd-count.component.html',
                styleUrls: ['./vd-count.component.scss']
            }]
    }], function () { return [{ type: i1.AppServicesLibraryService }]; }, { inputParams: [{
            type: Input
        }] }); })();

class VdCountModule {
}
VdCountModule.ɵfac = function VdCountModule_Factory(t) { return new (t || VdCountModule)(); };
VdCountModule.ɵmod = i0.ɵɵdefineNgModule({ type: VdCountModule });
VdCountModule.ɵinj = i0.ɵɵdefineInjector({ imports: [[]] });
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(VdCountModule, { declarations: [VdCountComponent], exports: [VdCountComponent] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(VdCountModule, [{
        type: NgModule,
        args: [{
                declarations: [VdCountComponent],
                imports: [],
                exports: [VdCountComponent]
            }]
    }], null, null); })();

/*
 * Public API Surface of vd-count
 */

/**
 * Generated bundle index. Do not edit.
 */

export { VdCountComponent, VdCountModule, VdCountService };
//# sourceMappingURL=vd-count.js.map
